const metrics = [
  { name: 'Overall Experience', value: 87 },
  { name: 'Wait Times', value: 72 },
  { name: 'Staff Friendliness', value: 94 },
  { name: 'Treatment Effectiveness', value: 89 },
];

export default function PatientSatisfactionChart() {
  return (
    <div className="rounded-lg border bg-card bg-white shadow-sm p-4">
      <h2 className="text-xl font-semibold leading-tight mb-2 tracking-tight">Patient Satisfaction</h2>
      <p className="text-sm text-muted-foreground mb-4">Based on feedback surveys</p>
      <div className="space-y-4">
        {metrics.map((item, i) => (
          <div key={i}>
            <div className="flex justify-between mb-1 text-sm font-medium">
              <span>{item.name}</span>
              <span>{item.value}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-green-500 h-2 rounded-full"
                style={{ width: `${item.value}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
